import React from "react";
import { Bookmark, Check, Heart, Star } from "lucide-react";
import { useMyCinema } from "../context/MyCinemaContext";
import { useTranslate } from "../context/TranslateContext";

export const MovieActions = ({ movieId, showRating = false }) => {
  const { inList, toggle, rate, data } = useMyCinema();
  const { t } = useTranslate();
  const myScore = data?.ratings?.[movieId];

  const Btn = ({ active, onClick, icon: Icon, label, activeClass, testId }) => (
    <button onClick={onClick} data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 font-body text-sm transition-colors duration-300 ${
        active ? activeClass : "border-edge bg-surface/70 text-cream hover:border-gold hover:text-gold"}`}>
      <Icon className={`h-4 w-4 ${active ? "fill-current" : ""}`} /> {t(label)}
    </button>
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap gap-3">
        <Btn testId={`action-watchlist-${movieId}`} active={inList("watchlist", movieId)} onClick={() => toggle("watchlist", movieId)}
          icon={inList("watchlist", movieId) ? Check : Bookmark} label={inList("watchlist", movieId) ? "In Watchlist" : "Add to Watchlist"}
          activeClass="border-gold bg-gold/15 text-gold" />
        <Btn testId={`action-watched-${movieId}`} active={inList("watched", movieId)} onClick={() => toggle("watched", movieId)}
          icon={Check} label={inList("watched", movieId) ? "Watched" : "Mark Watched"} activeClass="border-teal2 bg-teal2/15 text-teal2" />
        <Btn testId={`action-fav-${movieId}`} active={inList("favorites", movieId)} onClick={() => toggle("favorites", movieId)}
          icon={Heart} label="Favourite" activeClass="border-crimson bg-crimson/15 text-crimson" />
      </div>
      {showRating && (
        <div className="flex items-center gap-1" data-testid={`rating-${movieId}`}>
          <span className="mr-2 font-body text-sm text-ash">{t("Your rating")}:</span>
          {[2, 4, 6, 8, 10].map((s) => (
            <button key={s} onClick={() => rate(movieId, s)} data-testid={`rate-${movieId}-${s}`} aria-label={`Rate ${s}`}
              className="p-0.5">
              <Star className={`h-6 w-6 transition-colors duration-200 ${myScore >= s ? "fill-gold text-gold" : "text-edge hover:text-gold/60"}`} />
            </button>
          ))}
          {myScore ? <span className="ml-2 font-body text-sm text-gold">{myScore}/10</span> : null}
        </div>
      )}
    </div>
  );
};
